module.exports = __webpack_public_path__ + "images/icon-price-lock-light.png";